export default __webpack_public_path__ + "assets/audio/切り傷.296a8c0a.m4a";